<template id="bs-modal-campaign">
<div class="modal fade" id="campaignCreateModal" tabindex="-1" role="dialog" aria-labelledby="campaignCreateModal">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">

			<div class="text-gray-500 font-weight-bold text-uppercase text-base bg-gray-100 px-3 py-25 rounded-top border-bottom">
				<span>Create Campaign</span>
				<button type="button" class="close" data-dismiss="modal" aria-label="Close">
		        	<span aria-hidden="true">&times;</span>
		        </button>
			</div>

			<div class="modal-body py-0 px-3">
				<form @submit.prevent="submitForm" @keydown="form.onKeydown($event)" @change="form.onKeydown($event)">	
					<div class="row">
						<div class="d-flex flex-column col-sm-5 pt-3 pb-3">
							<div class="flex-grow-1">

								<alert-errors :form="form">There were some problems with your input.</alert-errors>
								<alert-success :form="form">Your campaign was saved!</alert-success>
					
								<div class="form-group">
									<label class="mb-0">Title</label>
									<input type="text" class="form-control" v-model="form.title" data-test="campaignTitle" required>
								</div>

								<div class="form-group">
									<label class="mb-0">Type</label>
									<v-select	                            
			                            label="label"
			                            :options="[
			                            	{ label: 'Mailer', value: 'mail'},
			                            	{ label: 'Email', value: 'email'},
			                            	{ label: 'Event/Meeting', value: 'event'},
			                            	{ label: 'Phone', value: 'phone'},
			                            	{ label: 'Fax', value: 'fax'},
			                            ]"
			                            :reduce="label => label.value"
			                            v-model="form.type"
			                            :clearable="false"
			                            data-test="campaignType"
			                        />
								</div>

								<div class="form-group">
									<label class="mb-0">Assigned To <span class="text-gray-500"> - Optional</span></label>
									<v-select			                            
			                            label="display_name"
			                            :options="options.user_ids"
			                            :reduce="display_name => display_name.id"
			                            v-model="form.assigned_user_id"
			                            data-test="campaignUser"
			                        />
									<small class="form-text text-gray-500">Defaults to you if no user assigned</small>	
								</div>

								<div class="form-group">
									<label class="mb-0">Complete By <span class="text-gray-500"> - Optional</span></label>
									<date-picker 
										readonly="true"
										class="date-picker"
										v-model="form.complete_by"
										:config="config.datePickerOptions"
										data-test="campaignEndDate"
									/>
								</div>

								<div class="form-group">
									<label class="mb-0">Description <span class="text-gray-500"> - Optional</span></label>
						            <vue-editor 
						                :editor-toolbar="config.editor.toolbar"
						                v-model="form.description"
						                data-test="campaignDescription"
						            />
								</div>
							</div>	

							<div class="d-none d-sm-flex button-wrap pt-3 px-3 justify-content-between">
								<span class="btn btn-ghost-secondary" @click="cancelCampaign()" data-dismiss="modal">Cancel</span>
								<button :disabled="form.busy" type="submit" class="btn btn-primary" data-test="saveCampaignButton">Add Campaign</button>
							</div>
						</div>



						<div class="campaign-stops col-sm-7 pb-0 pt-md-4 pt-3 bg-gray-200">
							<div class="form-group" v-if="campaign_stops">
								<label>Selected Providers</label>
								<p class="text-sm text-gray-700">Additional visits may be added after the campaign is saved.</p>
								<template v-if="save_physicians_first">
									<div class="alert alert-warning px-25 py-2">
										The following providers will be added to the system as physicians when the campaign is created.
									</div>
									<img v-if="in_progress" class="center-me" src="/images/loading-color.svg">
									<ol type="1" v-else>
										<li v-for="campaign_stop in campaign_stops">
											<strong>{{ campaign_stop.first_name }} {{ campaign_stop.last_name }}</strong>
										</li>
									</ol>									
								</template>
		
								<ol type="1" v-else class="mt-2" data-test="campaignVisitsPreset">
									<li v-for="campaign_stop in campaign_stops" class="mb-2">
										<div class="leading-tight font-weight-bold">{{ campaign_stop.display_name }}</div>
									</li>
								</ol>		
							</div>

							<template v-else>
								<p>
								Add providers to this campaign. Select all providers with a particular specialty or add individual providers. Additional visits may be added after the campaign is saved.
								</p>

								<div class="form-group">
									<label class="mb-0">Select Providers <span class="text-gray-500">- Optional</span></label>
									<v-select
										multiple
										label="display_name"
										:options="allProviderIds"
										v-model="form.visits"
										data-test="campaignStops"
									/>				
								</div>

								<div class="form-group">
									<label class="mb-0">Select Specialties <span class="text-gray-500">- Optional</span></label>
									<v-select
										multiple
										label="label"
										:options="options.specialties"
										:reduce="label => label.id"
										v-model="form.specialties"
										data-test="campaignSpecialties"
									/>				
								</div>
							</template>

							<div class="d-sm-none d-flex form-group justify-content-between button-wrap p-3 bg-white">
								<span class="btn btn-ghost-secondary" @click="cancelCampaign()" data-dismiss="modal">Cancel</span>
								<button :disabled="form.busy" type="submit" class="btn btn-primary">Add Campaign</button>
							</div>															
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
</template>


<script>

	import { mapGetters, mapState } from 'vuex';
	import { Form, HasError, AlertError, AlertErrors, AlertSuccess } from 'vform';

	export default {
		components: {
			HasError,
			AlertError,
			AlertErrors,
			AlertSuccess,
			Form,
		},

		data() {
			return {
				campaign_stops: null,
				form: {},
				in_progress: false,
			}
		},

		created() {
			this.createForm();
		},

		mounted() {
			let self = this;
			window.goToCampaign = function(campaign_id) {
				self.$router.push({ name: 'campaigns.show', params: { id: campaign_id } });
			};	

			this.$root.$on('build_campaign_modal', data => {
				this.campaign_stops = data.campaign_stops;
				this.save_physicians_first = data.save_physicians_first;
			});					
		},

		methods: {
			cancelCampaign() {
				this.createForm();
				this.campaign_stops = [];
			},

			createForm() {
				this.form = new Form({
					title: '',
					description: '',
					type: '',
					assigned_user_id: this.user.id,
					complete_by: null,
					visits: null,
					specialties: null,
					status: 0,
				});
			},

		    savePhysiciansThenCampaign() {
		    	this.in_progress = true;
		    	axios.post('/api/physicians/store_multiple', this.campaign_stops).then(({ data }) => { 
					//data is a the new physician objects. all we need are the new location IDs
					this.form.visits = data.map(item => ( { morphable_id: item.id, morphable_type: item.model }));
					this.submitCampaign();
					this.in_progress = false;
				});
		    },

			submitForm() {
				if (this.save_physicians_first) {
					this.savePhysiciansThenCampaign();
				} else {
					console.log('test');
					if (this.campaign_stops) {
						this.form.visits = this.campaign_stops;
					}
					this.submitCampaign();
				}
			},


			submitCampaign() {
		    	this.form.post('/api/campaigns').then(({ data }) => { 

					//return the new campaign
					this.$root.$emit('campaign_added', data);

					//forgive me, for I have sinned
					jQuery('#campaignCreateModal').modal('hide');

					//reset the form
					this.createForm();

					Swal.fire({
					    toast: true,
					    position: 'top-end',
					    showConfirmButton: false,
					    timer: 4000,
					    icon: 'success',
					    title: 'Campaign saved',
					    html: '<div><a href="#" onclick="goToCampaign(' + data.id + ')">View Campaign</div>',
					});	

		        })
		    },
		},

		computed: {
			...mapGetters(['allProviderIds']),
			...mapState(['config', 'options', 'user']),
		}

	}

</script>

<style scoped>
	.button-wrap {
		border-top:1px solid #e4e7ea;
		margin:0 -1rem; }

	.campaign-stops {
		box-shadow:inset 0px 7px 9px -7px rgba(0,0,0,0.4);
	}

	i.refresh { 
		cursor:pointer !important;
	}

	@media (min-width: 576px) { 
		.campaign-stops {
			box-shadow:inset 7px 0 9px -7px rgba(0,0,0,0.4);
		}
	}
</style>